import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../shared/globals';
import { AuthService } from './auth.service';
import { StationOwnerMoneyAccount } from '../models/user.model';
import { Api } from '../shared/api';

@Injectable()
export class MoneyAccountService {
  private moneyAccountUrl: string;

  constructor(
    private readonly api: Api,
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals
  ) {
    this.moneyAccountUrl = globals.apiUrl('MoneyAccount');
  }

  getTempAccountLink(refreshUrl: string, returnUrl: string): Promise<string> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .get(
            `${this.globals.apiUrl(
              'StripeAccounts'
            )}?refreshUrl=${refreshUrl}&returnUrl=${returnUrl}`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: basicToken,
              },
            }
          )
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject(err);
      });
  }

  async createOrUpdateMoneyAccount(
    stationOwnerMoneyAccount: StationOwnerMoneyAccount
  ) {
    await this.api.httpPut(`${this.moneyAccountUrl}`, stationOwnerMoneyAccount);
  }
}
